<template>
    <transition>
        <div
            class="cookie-banner"
            v-if="!cookieAcceptance && !declined"
        >
            <div class="content">
                <div class="caption">
                    <p>{{$t('cookiebanner.description')}}</p>
                    <router-link :to="{ name: 'Termsofuse' }" aria-label="Learn more">{{$t('cookiebanner.more')}}</router-link>
                </div>
                <div class="cta-container">
                    <button aria-label="Call to action accept cookies" role="button" @click="accept">{{$t('cookiebanner.accept')}}</button>
                    <button aria-label="Call to action decline cookies" role="button" @click="decline">{{$t('cookiebanner.decline')}}</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { cookieAcceptance } from '@/store/index'
export default {
    data()
    {
        return {
            cookieAcceptance,
            declined: false
        }
    },
    methods: {
        accept()
        {
            const current = Date.now()
            localStorage.setItem('cookieAcceptance', current)
            this.cookieAcceptance = current
        },
        decline()
        {
            this.declined = true
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.cookie-banner
    position: fixed
    bottom: 0
    left: 0
    right: 0
    z-index: 3
    margin: auto
    max-width: 1130px
    width: 100%
    display: flex
    align-items: center
    overflow: hidden
    box-shadow: 0 0 8px rgba(0, 0, 0, .15)
    background-color: #ffffff
    &.v-enter-active,
    &.v-leave-active
        transition: transform .625s ease
    &.v-enter,
    &.v-leave-to
        transform: translateY(100%)
        .content
            transform: translateY(-100%)


.content
    height: 100%
    width: 100%
    display: flex
    align-items: center
    padding: 0 4.8%
    transition: transform .625s ease
    padding-top: 26px
    padding-bottom: 26px
    @include media-breakpoint-down($lg)
        flex-direction: column
        padding-left: 8.6%
        padding-right: 8.6%
.caption
    flex: 1
    display: flex
    line-height: 1.3
    p
        @include media-breakpoint-down($lg)
            display: inline
    @include media-breakpoint-down($lg)
        margin-bottom: 1.8em
        font-size: 12px
        display: block
    a
        margin-left: .3em
        @include media-breakpoint-down($lg)
            // margin-left: 38px
button
    margin-left: 38px
    cursor: pointer
    @include media-breakpoint-down($lg)
        font-size: 14px

        margin-left: 19px
        margin-right: 19px

</style>
